// Thin wrapper around globalThis.location — extracted so tests can mock it
// without fighting jsdom's non-configurable window.location descriptor.
export const getCurrentPathname = () => globalThis.location.pathname;
